/*** IMPORTS FROM imports-loader ***/
var jQuery = require("jquery");
var $ = require("jquery");

import React from 'react';
import 'echarts/lib/chart/line';
import 'echarts/lib/component/tooltip';
import 'echarts/lib/component/title';
import 'echarts/lib/component/legend';
import 'echarts/lib/component/grid';
import 'echarts/lib/component/dataZoom';
import echarts from 'echarts/lib/echarts';
import { connect } from 'react-redux';
import styles from './styles.scss';

const kColors = [
  '#22A7F0',
  '#00B16A',
  '#F7CA18',
  '#F9690E',
  '#EF4836',
  '#DB0A5B',
  '#663399',
  '#BF55EC',
  '#446CB3',
  '#336E7B',
  '#1BBC9B',
];

const defaultProps = {
  title: null,
  legend: [],
  grid: null,
  xAxis: null,
  yAxis: null,
  dataZoom: null,
  tooltip: {},
  resize: null,
  collapsed: false,
  colorShift: 0,
  height: null,
  colors: kColors,
};
const propTypes = {
  series: React.PropTypes.array.isRequired,
  categories: React.PropTypes.array.isRequired,
  title: React.PropTypes.any,
  legend: React.PropTypes.any,
  grid: React.PropTypes.any,
  xAxis: React.PropTypes.any,
  yAxis: React.PropTypes.any,
  dataZoom: React.PropTypes.any,
  tooltip: React.PropTypes.object,
  colorShift: React.PropTypes.number,
  colors: React.PropTypes.array,
  height: React.PropTypes.number,
};

const kyAxis = {
  name: '',
  axisLine: {
    lineStyle: {
      color: '#ABB7B7',
    },
  },
  splitLine: {
    lineStyle: {
      color: ['#ECF0F1', '#DADFE1'],
      type: 'dotted',
    },
  },
};

class LineChart extends React.Component {

  constructor(props) {
    super(props);
    this.state = {
      series: props.series,
      categories: props.categories,
      legend: props.legend,
    };
    this.tryResizeChart = this.tryResizeChart.bind(this);
  }

  componentDidMount() {
    this.echart = this.initChart();
    this.echart.resize();
    $(window).resize(this.tryResizeChart);
  }

  componentWillReceiveProps(nextProps) {
    const { series, categories, legend, yAxis } = nextProps;
    if (series !== this.props.series) {
      this.updateChart(series, categories, legend, yAxis);
      this.setState({
        series: nextProps.series,
        categories: nextProps.categories,
        legend: nextProps.legend,
      });
    }
    this.tryResizeChart();
  }

  componentWillUnmount() {
    echarts.dispose($(this.chartRef));
    $(window).off('resize', this.tryResizeChart);
  }

  colors() {
    const { colorShift, colors } = this.props;
    if (colorShift > 0) {
      return _.concat(
        _.drop(colors, colorShift),
        _.take(colors, colorShift),
      );
    }
    return colors;
  }

  tryResizeChart() {
    const width = $(this.chartRef).width();
    const height = $(this.chartRef).height();
    if (height !== this.height || width !== this.width) {
      if (this.echart) {
        this.echart.resize();
      }
    }
    this.width = width;
    this.height = height;
  }

  updateChart(nextSeries, nextCategories, nextLegend, nextyAxis) {
    const { series: thisSeries } = this.state;
    const series = nextSeries.map(s => (
      _.extend({
        type: 'line',
      }, s)
    ));
    const legend = nextLegend || [];
    let yAxis = kyAxis;
    if (nextyAxis) {
      if (_.isArray(nextyAxis)) {
        yAxis = nextyAxis.map(ya => _.extend({}, yAxis, ya));
      } else {
        yAxis = _.extend(yAxis, nextyAxis);
      }
    }
    const option = {
      ...this.echart.getOption(),
      yAxis,
      series,
      legend,
    };
    if (nextCategories) {
      option.xAxis = {
        data: nextCategories,
      };
    }
    if (!_.isEqual(
          _.map(thisSeries, 'name'),
          _.map(nextSeries, 'name'))) {
      // reset option
      this.echart.clear();
    }
    this.echart.setOption(option);
    this.echart.resize();
  }

  initChart() {
    const echart = echarts.init(this.chartRef);
    const series = this.state.series.map(s => ({
      name: s.name,
      data: s.data,
      type: 'line',
      lineStyle: {
        normal: {
          width: 2,
        },
      },
      areaStyle: {
        normal: {
          opacity: 0.1,
        },
      },
      ...s,
    }));

    // xAxis
    let xAxis = {
      name: '',
      axisLine: {
        lineStyle: {
          color: '#ABB7B7',
        },
      },
      splitLine: {
        show: false,
      },
      axisTick: {
        alignWithLabel: true,
      },
      boundaryGap: true,
    };
    if (this.props.xAxis) {
      if (_.isArray(this.props.xAxis)) {
        xAxis = this.props.xAxis.map(xa => _.extend({}, xAxis, xa));
      } else {
        xAxis = _.extend(xAxis, this.props.xAxis);
      }
    }

    // yAxis
    let yAxis = kyAxis;
    if (this.props.yAxis) {
      if (_.isArray(this.props.yAxis)) {
        yAxis = this.props.yAxis.map(ya => _.extend({}, yAxis, ya));
      } else {
        yAxis = _.extend(yAxis, this.props.yAxis);
      }
    }

    const { legend, grid, dataZoom, tooltip, title } = this.props;
    const option = {
      title,
      xAxis,
      yAxis,
      legend,
      series,
      dataZoom,
      grid,
      color: this.colors(),
      textStyle: {
        fontSize: 12,
        fontWeight: 300,
      },
      tooltip: {
        trigger: 'axis',
        ...tooltip,
      },
      animationEasing: 'cubicIn',
      showLoading: true,
    };
    if (this.state.categories) {
      option.xAxis.data = this.state.categories;
    }
    echart.setOption(option);
    return echart;
  }

  render() {
    const { height } = this.props;

    return (
      <div
        className={styles.chart}
        style={{ height }}
        ref={(ref) => { this.chartRef = ref; }}
      />
    );
  }
}

LineChart.propTypes = propTypes;
LineChart.defaultProps = defaultProps;

const mapStateToProps = state => ({
  collapsed: state.sidebar.collapsed,
});

export default connect(mapStateToProps, null)(LineChart);




// WEBPACK FOOTER //
// ./src/components/LineChart/index.jsx